import jQuery from "jquery";
import {ACTION, Events} from "../events";
// import {ACTION, Events} from "../events";

jQuery(document).ready(function ($) {
    const $sideBar = $(".ex_some_sidebar--floating");
    window.setTimeout(function () {
        $sideBar.addClass("visible");
    }, 2000);

    const onMenuPinnedActive = function() {
        if ($("body").hasClass("home"))
            $sideBar.addClass('menu-pinned');
    }

    const onMenuPinnedInactive = function() {
        $sideBar.removeClass('menu-pinned');
    }


    Events.on(ACTION.MENU_PINNED_ACTIVE, onMenuPinnedActive, this);
    Events.on(ACTION.MENU_PINNED_INACTIVE, onMenuPinnedInactive, this);
});